import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Importe suas páginas normalmente
import LandingPage from './pages/LandingPage';
import ConversaoPage from './pages/ConversaoPage';
import LoginPage from './pages/LoginPage';
import RegistroPage from './pages/RegistroPage';
import DashboardPage from './pages/DashboardPage';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import TermosServico from './pages/TermosServico';
import AgendaPublica from './pages/AgendaPublica';

// IMPORTAÇÃO CHAVE: Aqui você traz o componente seguro que criamos em um arquivo separado
// (Ajuste o './components/' dependendo de onde você salvou o arquivo)
import PrivateRoute from './pages/PrivateRoute'; 

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/experimente" element={<ConversaoPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegistroPage />} />
          
          {/* Rota Protegida usando o NOVO PrivateRoute importado lá em cima */}
          <Route 
            path="/dashboard" 
            element={
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            } 
          />
          
          <Route path="/termo-servico" element={<TermosServico />} />
          <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
          {/* Link público de agendamento: fica na raiz do domínio para ficar mais compacto
              (ex: agendasincro.com.br/salao-da-maria). Rotas estáticas acima sempre têm
              prioridade de match no react-router, então não colidem com esta. */}
          <Route path="/:slug" element={<AgendaPublica />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;